/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow': {
    width: 357,
    height: 357,
    viewBox: '0 0 357 357',
    data: '<path pid="0" d="M38.25 0v357l280.5-178.5z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/arrow.js